import { singleton } from 'tsyringe';

@singleton()
export default class PromiseTimeout {
  public static timeout(
    ms: number,
    promise: Promise<any>,
    eventCallback: Function,
  ): Promise<any> {
    let id: any;
    const timeout = new Promise((resolve) => {
      id = setTimeout(() => {
        resolve(eventCallback());
      }, ms);
    });

    return Promise.race([
      promise,
      timeout,
    ]).then((result) => {
      clearTimeout(id);
      return result;
    });
  }
}
